import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './AtlasLogoShort.styles';

type AtlasLogoShortIconProps = WithStyles<typeof styles>;

const AtlasLogoShortIconComponent: FC<AtlasLogoShortIconProps> = ({ classes }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      classes={{ root: classes.root }}
    >
      <rect width="32" height="32" rx="6" fill="#A270DE" />
      <path
        d="M22.8611 8.72379L17.9224 13.1125L16 14.8212L14.0755 13.1115L9.13983 8.72582C9.96228 7.94996 10.9164 7.31185 11.9647 6.84999L15.9989 11.0909L20.0362 6.84796C21.0845 7.30983 22.0386 7.94793 22.8611 8.72379Z"
        fill="white"
      />
      <path
        d="M16.0021 9.12773C16.8658 9.12773 17.566 8.42756 17.566 7.56387C17.566 6.70017 16.8658 6 16.0021 6C15.1384 6 14.4382 6.70017 14.4382 7.56387C14.4382 8.42756 15.1384 9.12773 16.0021 9.12773Z"
        fill="white"
      />
      <path
        d="M22.8611 23.2774L17.9224 18.8887L16 17.18L14.0755 18.8897L9.13983 23.2754C9.96228 24.0513 10.9164 24.6894 11.9647 25.1513L15.9989 20.9104L20.0362 25.1533C21.0845 24.6914 22.0386 24.0533 22.8611 23.2774Z"
        fill="white"
      />
      <path
        d="M16.0021 25.9999C16.8658 25.9999 17.566 25.2997 17.566 24.436C17.566 23.5723 16.8658 22.8721 16.0021 22.8721C15.1384 22.8721 14.4382 23.5723 14.4382 24.436C14.4382 25.2997 15.1384 25.9999 16.0021 25.9999Z"
        fill="white"
      />
      <path
        d="M23.2774 22.8614L18.8887 17.9226L17.18 16.0002L18.8897 14.0758L23.2754 9.14008C24.0513 9.96252 24.6894 10.9166 25.1512 11.965L20.9104 15.9992L25.1533 20.0365C24.6914 21.0848 24.0533 22.0389 23.2774 22.8614Z"
        fill="white"
      />
      <path
        d="M24.4361 17.566C25.2998 17.566 26 16.8659 26 16.0022C26 15.1385 25.2998 14.4383 24.4361 14.4383C23.5724 14.4383 22.8723 15.1385 22.8723 16.0022C22.8723 16.8659 23.5724 17.566 24.4361 17.566Z"
        fill="white"
      />
      <path
        d="M8.7236 22.8614L13.1123 17.9226L14.821 16.0002L13.1113 14.0758L8.72563 9.14008C7.94977 9.96252 7.31167 10.9166 6.8498 11.965L11.0907 15.9992L6.84778 20.0365C7.30964 21.0848 7.94775 22.0389 8.7236 22.8614Z"
        fill="white"
      />
      <path
        d="M7.56386 17.566C8.42756 17.566 9.12772 16.8659 9.12772 16.0022C9.12772 15.1385 8.42756 14.4383 7.56386 14.4383C6.70016 14.4383 6 15.1385 6 16.0022C6 16.8659 6.70016 17.566 7.56386 17.566Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const AtlasLogoShortIcon = withStyles(styles)(AtlasLogoShortIconComponent);
